import { useState } from 'react'
import {
    ProductBackground, ProductImage, ProductContainer,
    ProductContent, ProductTitle, ProductSubtitle,
    ProductScores, ProductScoreItem, ProductItems,
    ProductScoreTitle, ProductScoreSubtitle, ProductItem, ProductItemImage, ProductSubitems,
    ProductDescription, ProductPrices, ProductPrice, ProductParagraph,
    ProductButton, ProductTable, ProductTableItem
} from './styled';
import { ProductDetailTypes } from 'global/globalTypes';
import { useMediaQuery } from 'utils/media-query';
import productMock from 'assets/images/mock-product.png';
import { dateFormat } from 'utils/dateFormat';

import mockWriter from '../assets/mock-writer.png'
import RatingBar from '../RatingBar'

function ProductDetail({
    images,
    brand,
    model,
    alt,
    paragraphs,
    specifications,
    firstProduct,
    createdAt,
    author,
    price,
    csavPrice,
    csavUrl,
    scores
}: ProductDetailTypes) {
    const isMobile = useMediaQuery('mobile');
    const [imageLoaded, setImageLoaded] = useState(false);

    let isRight = false

    const img = new Image();

    img.src = images[0]?.image;
    img.onload = function () {
        setImageLoaded(true)
    };

    return (
        <ProductBackground firstProduct={firstProduct}>
            <ProductContainer>
                <ProductImage
                    src={imageLoaded ? images[0]?.image : productMock}
                    alt={alt}
                    loading="lazy"
                    effect="blur"
                    // placeholderSrc={background}
                    width={isMobile ? '100%' : '55%'}
                    height={isMobile ? '300px' : '400px'}
                />
                <ProductContent intro={true}>
                    <ProductTitle>{brand} {model}</ProductTitle>
                    <ProductItems>
                        <ProductItemImage src={author.headshot ? author.headshot : mockWriter} alt='writer' />
                        <ProductSubitems>
                            <ProductItem>Writer: <span>{author.name}</span></ProductItem>
                            {author?.position ? <ProductItem><i>{author.position}</i></ProductItem> : null}
                            <ProductItem>{dateFormat(createdAt)}</ProductItem>
                        </ProductSubitems>
                    </ProductItems>
                    <ProductDescription>{paragraphs[0]?.text}</ProductDescription>
                    <ProductPrices>
                        <ProductPrice priceColor='#E97070' priceCSAVColor='#E97070'>MSRP: <span>${price}</span></ProductPrice>
                        <ProductPrice priceColor='#4F7FA7' priceCSAVColor='#0E4574'>Chester Springs AV price: <span>${csavPrice}</span></ProductPrice>
                    </ProductPrices>
                    <a href={csavUrl} target='_blank' rel="noreferrer">
                        <ProductButton className='primary-button'>Purchase</ProductButton>
                    </a>
                </ProductContent>
            </ProductContainer>
            <ProductContent>
                <ProductSubtitle>Key specifications</ProductSubtitle>
                <ProductTable>
                    {specifications.map(({ id, name, value }: any) => (
                        <ProductTableItem key={id}>
                            <p>{name}</p>
                            <p>{value}</p>
                        </ProductTableItem>
                    ))}
                </ProductTable>

                {paragraphs.slice(1).map((paragraphs) => {
                    if (paragraphs?.image) {
                        isRight = !isRight
                    }

                    return (
                        <ProductParagraph key={paragraphs.id} even={isRight}>
                            <div className={paragraphs.image ? 'half' : ''}>
                                <ProductSubtitle>{paragraphs.title}</ProductSubtitle>
                                <ProductDescription>{paragraphs.text}</ProductDescription>
                            </div>
                            {paragraphs?.image && (
                                <img src={paragraphs.image} alt={paragraphs.title.slice(0).toLocaleLowerCase()} />
                            )}
                        </ProductParagraph>
                    )
                })}

                {scores.length > 0 ?
                    <ProductScores>
                        <ProductScoreTitle>Scores from our team</ProductScoreTitle>
                        <ProductScoreSubtitle>Scale 1-10</ProductScoreSubtitle>
                        {scores.map(({ id, name, value }: any) => (
                            <ProductScoreItem key={id}>
                                <p>{name}</p>
                                <RatingBar score={value} />
                            </ProductScoreItem>
                        ))}
                    </ProductScores>
                    : null}
            </ProductContent>
        </ProductBackground>
    );
}

export default ProductDetail;
